export default __webpack_public_path__ + "static/jellow-left-min-72bae3e976e35588ddd1dd3e3e9373a0.png";